import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BaseToolDetail} from 'llm/deep-research/tool-details/BaseToolDetail';
import {QueryWarehouseToolDetail} from 'llm/deep-research/tool-details/QueryWarehouseToolDetail';
import {
  DeepResearchToolType,
  ProgressToolCall,
  QueryWarehouseToolCall,
  TOOL_DESCRIPTIONS,
  TOOL_ICONS,
} from 'llm/deep-research/tool-details/types';
import {FONT_PROXIMA_18, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {GRAY_DARKER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface ToolDetailProps {
  toolCall: ProgressToolCall;
}

/**
 * Component for displaying detailed information about a specific tool call.
 * Acts as a wrapper that renders the appropriate specific tool component.
 */
export function ToolDetail({toolCall}: ToolDetailProps): JSX.Element {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.header)}>
        <BenchlingIcon icon={TOOL_ICONS[toolCall.tool]} className={css(styles.toolIcon)} />
        <div className={css(styles.toolName)}>{TOOL_DESCRIPTIONS[toolCall.tool]}</div>
      </div>

      <div className={css(styles.content)}>
        {toolCall.tool === DeepResearchToolType.QueryWarehouseTool ? (
          <QueryWarehouseToolDetail toolCall={toolCall as QueryWarehouseToolCall} />
        ) : (
          <BaseToolDetail toolCall={toolCall} />
        )}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '4px',
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '12px',
  },

  toolIcon: {
    fontSize: '18px',
    color: GRAY_DARKER,
  },

  toolName: {
    ...FONT_PROXIMA_18,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    color: GRAY_DARKER,
  },

  content: {
    flex: 1,
  },
});
